import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Modal} from "../../../../../../../components/modal/modal.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../../utils/aggrid-utils.js";
import Button from "../../../../../../../components/button/button.jsx";
import {
    DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL_FLOATING_FILTERS
} from "../../../../../../../utils/ag-grid-columns-utils.js";

const ModalRemoveUsers = ({show, setShow, responsible, setResponsible}) => {
    const [gridApi, setGridApi] = useState(null);
    const addUserGridRef = useRef(null);

    const columnDefsUsers = useMemo(() => [
        { headerName: "Nome", field: "name",
            flex: 1,
            comparator: aggridUtils.nullLastComparator,
            cellRenderer: params => {
                return (<span className={"cell-custom"}>{params.value}</span>)
            }
        },
        { headerName: "Nome de guerra", field: "namewar",
            flex: 1,
            comparator: aggridUtils.nullLastComparator,
            cellRenderer: params => {
                return (<span className={"cell-custom"}>{params.value}</span>)
            }
        },
    ], [])

    const remove = () => {
        const newData = gridApi.getSelectedRows();

        setResponsible(prev => {
            const idsToRemove = new Set(newData.map(item => item.id));
            return prev.filter(item => !idsToRemove.has(item.id));
        });

        setShow(false)
    }

    return (
        <Modal open={show} setOpen={setShow} title="Remover almoxarife" className="w-6/12">
            <Modal.Body>
                <div className="h-[calc(100vh-350px)] aggrid-row-pointer">
                    <AgGridReact
                        onGridReady={(params) => {
                            setGridApi(params.api);
                        }}
                        ref={addUserGridRef}
                        rowData={responsible}
                        columnDefs={columnDefsUsers}
                        defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL_FLOATING_FILTERS}
                        rowSelection={{
                            mode: 'multiRow',
                            enableSelectionWithoutKeys: true,
                            enableClickSelection: true,
                            checkboxes: false,
                            headerCheckbox: false,
                        }}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                        onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button target={"danger"} onClick={remove} actionFeedbackType="delete">Remover</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalRemoveUsers;